import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-set-read-button',
  templateUrl: './set-read-button.component.html',
  styleUrls: ['./set-read-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class SetReadButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
